import { Body5 } from '../../app/common/typography';
import styled from 'styled-components';

export const InfoMessageContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.xm};
  margin-bottom: ${({ theme }) => theme.spacing.l};
`;

export const Container = styled.div`
  width: 100%;
  align-items: center;
  height: 100dvh;
  text-align: center;
  background-color: ${({ theme }) => theme.colors.verdigrisDark};
  display: flex;
  justify-content: center;
`;

export const FrameSpacerContainer = styled.div`
  padding: ${({ theme }) => theme.spacing.m};
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
  text-align: left;
`;

export const LoginButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.l};
`;

export const ForgotPasswordWrapper = styled(Body5)`
  display: inline;
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;

export const PhoneNumberContainer = styled.div``;

export const LoginContainer = styled.div`
  & .phone-input-dropdown input[disabled] {
    background-color: #e1e1e1;
    color: #1f1f1f;
  }
`;
